import { render, staticRenderFns } from "./cropper.vue?vue&type=template&id=234aa82d&"
import script from "./cropper.vue?vue&type=script&lang=js&"
export * from "./cropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234aa82d')) {
      api.createRecord('234aa82d', component.options)
    } else {
      api.reload('234aa82d', component.options)
    }
    module.hot.accept("./cropper.vue?vue&type=template&id=234aa82d&", function () {
      api.rerender('234aa82d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/cropper.vue"
export default component.exports